import SlideContent from './SlideContent';

export default SlideContent;
